export default __webpack_public_path__ + "static/media/img7.61f64f68.jpg";